import styled from "styled-components";

export const BasicTableDiv = styled.div`
  th,
  td {
    padding: 10px;
    font-size: 12px;
  }
`;

export const TableBar = styled.div`
  max-width: 1440px;
  padding: 2rem;
  margin: 0 auto;

  .buttons {
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;

    .search {
      display: flex;
      align-items: center;
      border: 0.5px solid lightgray;
      padding: 3px;
      background: #fff;

      input {
        border: none;
        outline: none;
      }
    }
  }
`;
